import React from 'react';
import PropTypes from 'prop-types';

const FacesheetMessage = ({ title, description }) => (
  <div className="flex justify-center items-center min-h-screen bg-medium-fill-blue">
    <div className="w-771px h-56 rounded bg-white flex flex-col items-center justify-center">
      <h2 className="font-semibold text-xl leading-7 text-black mb-6 text-center m-0">
        {title}
      </h2>
      <span className="font-normal text-sm leading-5 text-brand-blue max-w-xl h-10 text-center block">
        {description}
      </span>
    </div>
  </div>
);

FacesheetMessage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default FacesheetMessage;
